import { SchoolYear } from "./common-types";

export enum CourseType {
    AP = "AP",
    DUAL_ENROLLMENT = "Dual Enrollment",
    HONOR = "Honor",
    IB = "IB",
    REGULAR = "Regular",
  }
  
export enum CourseGrade {
    A_PLUS = 'A+',
    A = 'A',
    A_MINUS = 'A-',
    B_PLUS = 'B+',
    B = 'B',
    B_MINUS = 'B-',
    C_PLUS = 'C+',
    C = 'C',
    C_MINUS = 'C-',
    D_PLUS = 'D+',
    D = 'D',
    D_MINUS = 'D-',
    F = 'F',
    N = 'Not Available Yet',
  }
  
export enum Score_IB {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
    SIX = 6,
    SEVEN = 7,
  }

export enum Score_AP_Exam {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,    
}

export interface StandardizedTest {
    user_id: number; // the user_id retrieved during log-in
    sat?: number;
    act?: number;
  }

export interface GPA {
    user_id: number; // the user_id retrieved during log-in
    ninth?: number;
    tenth?: number;
    eleventh?: number;
    twelfth?: number;
    overall?: number;
  }

export interface Course {
    id: number; // The id generated by database auto increment, uniquely identify a course
    user_id: number;
    name?: string; 
    year?: SchoolYear;
    type?: CourseType; 
    grade?: CourseGrade;
    score?: Score_IB; 
  }

export interface ApExam {
    id: number; // auto inc id from database, unique identifier
    user_id: number;
    name?: string;
    year?: SchoolYear;
    score?: Score_AP_Exam;
}

